import { Logo } from "app/features/navigation/atoms/Logo";
import { View } from "ui/atoms/view";

export function CardLogo() {
  return (
    <View className="flex items-center">
      <Logo></Logo>
    </View>
  );
}
